import React from 'react';
import { Card, B1, P2, Button, Row, Col, TextLink } from 'pfm-ui-components';
import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import * as constants from '../../../constants/RiskProfileCard';
import ChevronRight from '../../../assets/icons/chevron-right.svg';
import MyProfileIcon from '../../../assets/icons/my-profile.svg';
import AxisSelectCardSvg from '../../../assets/icons/invest.svg';
import RiskReturnsIcon from '../../../assets/icons/risk-returns.svg';
import { pxToRem } from '../../../styles/utils';
import { featureToggle } from '../../../constants/common';
import router from 'next/router';
import { routes } from '../../../config/routes';

interface RiskProfileCardProps {
  onClick: Function;
  isProfilePage?: boolean; // Whether its a profile page card
  header?: string; // heading of the card
  description?: string; // description of the card
  actionText?: string; // action text to be displayed on the card
  lighterHeading?: boolean; // is the heading font color bold/normal
}

const RiskProfileCard = (props: RiskProfileCardProps) => {
  const { onClick, isProfilePage, header, description, actionText, lighterHeading } = props;

  return (
    <>
      <CardWrapper>
        <AxisSelectCardWrapper onClick={() => onClick()}>
          <StyledCard canBeHovered>
            <CardContainer>
              <Wrapper>
                {/* If its a my profile page card display my profile logo or else display risk based profile logo*/}
                <LogoWrapper isProfilePage={isProfilePage}>
                  {isProfilePage ? <MyProfileLogo /> : <Logo id="mf_risk_profile_card" />}
                </LogoWrapper>
                <CardContent>
                  <Header lighterHeading={lighterHeading}>{header || constants.HEADER}</Header>
                  <Paragraph>{description || constants.DESCRIPTION}</Paragraph>
                  {!featureToggle.INVEST_BASIS_RISK_PROFILE && !isProfilePage && (
                    <ComingSoonHeader>Coming soon..</ComingSoonHeader>
                  )}
                </CardContent>
              </Wrapper>
              {actionText ? (
                <>
                  <LinkIconWrapper>
                    <ChevronRight />
                  </LinkIconWrapper>
                  <StyledTextLink>{actionText}</StyledTextLink>
                </>
              ) : (
                <ButtonWrapper>
                  <CustomButton disabled={false} secondary>
                    {constants.BUTTON_NAMING}
                  </CustomButton>
                </ButtonWrapper>
              )}
            </CardContainer>
          </StyledCard>
        </AxisSelectCardWrapper>
        <br></br>
        <RiskReturnsCardWrapper
          onClick={() => {
            router.push(
              routes.FUNDS_WITH_MODERATE_TO_HIGH_RETURNS.url + `?selectedReturns=${'high'}`,
              '/fundsWithModerateToHighReturns',
              {
                shallow: true,
              }
            );
          }}
        >
          <StyledCard canBeHovered>
            <CardContainer>
              <Wrapper>
                {/* If its a my profile page card display my profile logo or else display risk based profile logo*/}
                <RiskReturnsWrapper>
                  <LogoWrapper isProfilePage={isProfilePage}>
                    {isProfilePage ? <MyProfileLogo /> : <RiskReturnsIcon />}
                  </LogoWrapper>
                </RiskReturnsWrapper>
                <CardContent>
                  <RiskReturnsHeader lighterHeading={lighterHeading}>{header || constants.HEADER1}</RiskReturnsHeader>
                  <Paragraph>{description || constants.DESCRIPTION1}</Paragraph>
                  {!featureToggle.INVEST_BASIS_RISK_PROFILE && !isProfilePage && (
                    <ComingSoonHeader>Coming soon..</ComingSoonHeader>
                  )}
                </CardContent>
              </Wrapper>
              {actionText ? (
                <>
                  <LinkIconWrapper>
                    <ChevronRight />
                  </LinkIconWrapper>
                  <StyledTextLink>{actionText}</StyledTextLink>
                </>
              ) : (
                <ButtonWrapper>
                  <CustomButton disabled={false} secondary>
                    {constants.BUTTON_NAMING}
                  </CustomButton>
                </ButtonWrapper>
              )}
            </CardContainer>
          </StyledCard>
        </RiskReturnsCardWrapper>
      </CardWrapper>
    </>
  );
};

export default RiskProfileCard;

const AxisSelectCardWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: ${pxToRem(8)};
  :hover {
    cursor: pointer;
  }
  ${up('md')} {
    border-radius: ${pxToRem(12)};
  }
`;

const RiskReturnsWrapper = styled.div`
  margin: 6px 6px 0px 6px;
  //outline: 2px solid blue;
`;

const RiskReturnsCardWrapper = styled.div`
  width: auto;
  height: 100%;
  border-radius: ${pxToRem(8)};
  :hover {
    cursor: pointer;
  }
  ${up('md')} {
    border-radius: ${pxToRem(12)};
  }
`;

const CardWrapper = styled.div`
display: flex;
flex-direction: column;
flex: 100%;
`;

const StyledCard = styled(Card)`
  border-radius: ${pxToRem(8)};
  ${up('md')} {
    border-radius: ${pxToRem(12)};
  }
`;
const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: ${pxToRem(8)};
  height: ${pxToRem(120)};
  padding: ${pxToRem(4)} ${pxToRem(12)};
  ${up('md')} {
    height: ${pxToRem(148)};
    justify-content: space-between;
    margin: 0 ${pxToRem(40)};
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-around;
  padding-left: ${pxToRem(12)};
`;

const LogoWrapper = styled.div<{ isProfilePage: boolean }>`
  padding: 0 ${pxToRem(3)};
  /* If its a profile page card then do not give left padding */
  padding-left: ${(props) => (props.isProfilePage ? '0' : '0')};
  padding-top: ${pxToRem(4)};
  align-self: center;
  ${up('md')} {
    padding: 0;
  }
`;
const Logo = styled(AxisSelectCardSvg)`
  // width: ${pxToRem(46)};
  // height: ${pxToRem(46)};

  // ${up('md')} {
  //   width: ${pxToRem(72)};
  //   height: ${pxToRem(72)};
  // }
`;
const MyProfileLogo = styled(MyProfileIcon)`
  width: ${pxToRem(48)};
  height: ${pxToRem(48)};

  ${up('md')} {
    width: ${pxToRem(64)};
    height: ${pxToRem(64)};
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${pxToRem(8)};
  ${up('md')} {
    margin-left: ${pxToRem(24)};
    float: left;
  }
`;

const Header = styled(B1)<{ lighterHeading: boolean }>`
  margin-bottom: ${pxToRem(8)};
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(17)};
  color: #4a4a4a;
  width: auto;
  font-weight: ${(props) => (props.lighterHeading ? 'normal' : 'bold')};
  ${up('md')} {
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(19)};
  }
`;

const RiskReturnsHeader = styled(B1)<{ lighterHeading: boolean }>`
  margin-bottom: ${pxToRem(12)};
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(17)};
  //outline: 2px solid red;
  color: #4a4a4a;
  width: auto;
  font-weight: ${(props) => (props.lighterHeading ? 'normal' : 'bold')};
  ${up('md')} {
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(19)};
  }
`;

const Paragraph = styled(P2)`
  line-height: ${pxToRem(15)};
  color: ${(props) => props.theme.palette.grey3};
  ${up('md')} {
    line-height: ${pxToRem(17)};
  }
`;

const ButtonWrapper = styled.div`
  display: none;
  ${up('md')} {
    display: inline-block;
  }
`;

const CustomButton = styled(Button)`
  &:hover {
    background-color: ${(props) => props.theme.palette.white};
  }
  padding: ${pxToRem(12)} ${pxToRem(16)};
`;

const LinkIconWrapper = styled.div`
  ${up('md')} {
    display: none;
  }
`;
const StyledTextLink = styled(TextLink)`
  display: none;
  ${up('md')} {
    display: block;
  }
`;

const ComingSoonHeader = styled(B1)`
  color: ${(props) => props.theme.palette.black3};
  padding: ${pxToRem(4)} 0;
  ${up('md')} {
    padding: ${pxToRem(6)} 0;
  }
`;
